<script>

import Multiselect from 'vue-multiselect';

/* eslint-disable no-console */

export default {
  components: {
    Multiselect
  },
  data() {
    return {
      passSelectedId: 0,
      passSelected: null,
      selectedId: 0,
      selected: null,
      options: [],
      
    }
  },
  watch: {
    
    list: function(val) {
      
      this.options = val.data;
    
      if(this.auto && val.data.length == 1) {
        this.selected = this.options ? this.options[0] : null;
        this.selectedId = this.selected ? this.selected.id : 0;
        this.value = this.selectedId;
        this.$emit('input', this.selectedId);
      }

      this.getSelectedMethod();


    },
    value: function(val) {

      this.selectedId = val;
      this.passSelectedId = val;

      if(this.options.length !== 0) {
        this.getSelectedMethod();
      }
    },
  },
  computed: {
    validation() {
      return this.require ? this.value != null : null;
    },
  },
  props: {
    id: {
      type: String,
    },
    label: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    first: {
      type: String,
      default: 'general.please-select'
    },
    optionKey: {
      type: String,
      default: 'id'
    },
    prefix: {
      type: String,
      default: ''
    },
    postfix: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: 'label'
    },
    text2: null,
    require: {
      default: false
    },
    auto: {
      default: false,
    },
    list: {},
    value: null,
    disabled: {
      default: false
    },
    editable: {
      default: true
    },
    choose: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    getSelectedMethod: function() {
      //console.log("Selected");

      this.selected = this.selectedId !== 0 ? this.options.find((item) => item.id == this.selectedId) : null;

      if(this.passSelectedId != 0) {
        this.passSelected = this.options.find((item) => item.id == this.passSelectedId);
      }
    },
    updateValue: function(event) {
      
      // console.log(event);
      
      this.value = event.id;
      this.selectedId = event.id;
      this.$emit('input', event.id);
      this.$emit('change', event);

      Object.keys(this.$refs).map(el => {
        if(this.$refs[el][0] !== undefined) {
          
          (this.$refs[el][0]).blur();
        }
      });

      if(this.choose) {
        this.selected = undefined;
      }


    },
    searchChange: function(query) {
      this.$emit('search-change', query);
    },
    getList: function() {
      if(Object.keys(this.list).length !== 0)  {
        return this.list.data;
      } 
    },
    displayCustom: function(obj) {
      return this.text2 != null ? `${obj[this.text]} - (${obj[this.text2]})` :  `${obj[this.text]}`;
    },
    displayCustomMultiple: function(obj) {
      return `${obj[this.text]}`;
    },
    clearSelection() {
      
    },
  },
};
</script>
<template>
  <div class="form-group">
      <b-form-group
        class="mb-3"
        :label="$t(label)"
        :label-for="id"
      >
        <div v-if="editable || passSelected == null">
          <multiselect 
              :ref="id"
              @select="($event) => updateValue($event)"
              @search-change="($query) => searchChange($query)"
              :allowEmpty="true"
              :disabled="disabled"
              :options="options"
              :clearOnSelect="true"
              :placeholder="$t(first)" 
              :custom-label="displayCustom"
              :label="value" 
              :track-by="value">
              <template slot="noOptions">
                  <span>Oops! No list items.</span> 
              </template>
              <template slot="noResult">
                  <span>Oops! No list items.</span>
              </template>
          </multiselect>
        </div>
        <div v-else>
          <b-form-input
            :id="id"
            :type="type"
            :disabled="true"
            :placeholder="placeholder == '' ? $t(label) : $t(placeholder)"
            :value="text2 != null ? `${passSelected[text]} - (${passSelected[text2]})` :  `${passSelected[text]}`"
            :state="validation"
          ></b-form-input>
        </div>
        <i v-show="editable || passSelected == null" style="position: absolute; right: 20px; top: 35px; background-color: white" class='bx bx-chevron-down font-size-24'></i>
        <b-form-invalid-feedback v-show="require" :state="validation">
          <span>{{`${$t('general.please-enter')} ${$t(label)}`}}</span>
        </b-form-invalid-feedback>
      </b-form-group>
      
    
  </div>
</template>